export type ComponentVariant = 'variantA' | 'variantB' | 'variantC' | 'variantD' | 'variantRSD' | string;
